import { useState, useRef } from "react";
import CountUp from "react-countup";
import VisibilitySensor from "react-visibility-sensor";

function AnimatedNumber({ number }) {
  const [hasAnimated, setHasAnimated] = useState(false);
  const numberRef = useRef(null);

  return (
    <div ref={numberRef}>
      <CountUp end={number}>
        {({ countUpRef, start }) => (
          <VisibilitySensor
            onChange={(isVisible) => {
              if (!hasAnimated && isVisible) {
                start();
                setHasAnimated(true);
              }
            }}
            delayedCall
            scrollCheck
            intervalDelay={300}
            resizeCheck
            partialVisibility
            minTopValue={100}
          >
            <span ref={countUpRef} />
          </VisibilitySensor>
        )}
      </CountUp>
    </div>
  );
}

export default AnimatedNumber;
